exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".global-components-___DataTable__rowActions___1g2sb {\n    color: #0DA79D !important;\n}\n\n.global-components-___DataTable__rowActions___1g2sb>div {\n    margin-right: 15px;\n    cursor: pointer;\n}\n\n.global-components-___DataTable__rowActions___1g2sb>div:hover {\n    text-decoration: underline;\n}\n\n.global-components-___DataTable__rowActions___1g2sb>div:last-child {\n    margin-right: 0px;\n}\n", ""]);

// Exports
exports.locals = {
	"rowActions": "global-components-___DataTable__rowActions___1g2sb"
};